export const modern = [
  {
    number: 'M001',
    hasModel: false
  },
  {
    number: 'M002',
    hasModel: false
  },
  {
    number: 'M003',
    hasModel: false
  },
  {
    number: 'M004',
    hasModel: false
  },
  {
    number: 'M005',
    hasModel: false
  },
  {
    number: 'M006',
    hasModel: false
  },
  {
    number: 'M007',
    hasModel: false
  },
  {
    number: 'M008',
    hasModel: false
  },
  {
    number: 'M009',
    hasModel: false
  },
  {
    number: 'M089',
    hasModel: false
  },
  {
    number: 'M090',
    hasModel: false
  },
  {
    number: 'M091',
    hasModel: false
  },
  {
    number: 'M092',
    hasModel: false
  },
  {
    number: 'M093',
    hasModel: false
  },
  {
    number: 'M094',
    hasModel: false
  },
  {
    number: 'M095',
    hasModel: false
  },
  {
    number: 'M096',
    hasModel: false
  },
  {
    number: 'M097',
    hasModel: false
  },
  {
    number: 'M098',
    hasModel: false
  },
  {
    number: 'M099',
    hasModel: false
  },
  {
    number: 'M100',
    hasModel: false
  },
  {
    number: 'M101',
    hasModel: false
  },
  {
    number: 'M102',
    hasModel: false
  },
  {
    number: 'M103',
    hasModel: false
  },
  {
    number: 'M104',
    hasModel: false
  },
  {
    number: 'M105',
    hasModel: false
  },
  {
    number: 'M106',
    hasModel: false
  },
  {
    number: 'M107',
    hasModel: false
  },
  {
    number: 'M108',
    hasModel: false
  },
  {
    number: 'M109',
    hasModel: false
  },
  {
    number: 'M110',
    hasModel: false
  },
  {
    number: 'M111',
    hasModel: false
  },
  {
    number: 'M112',
    hasModel: false
  },
  {
    number: 'M113',
    hasModel: false
  },
  {
    number: 'M114',
    hasModel: false
  },
  {
    number: 'M115',
    hasModel: false
  },
  {
    number: 'M116',
    hasModel: false
  },
  {
    number: 'M117',
    hasModel: false
  },
  {
    number: 'M118',
    hasModel: false
  },
  {
    number: 'M119',
    hasModel: false
  },
  {
    number: 'M120',
    hasModel: false
  },
  {
    number: 'M121',
    hasModel: false
  },
  {
    number: 'M122',
    hasModel: false
  },
  {
    number: 'M123',
    hasModel: false
  },
  {
    number: 'M124',
    hasModel: false
  },
  {
    number: 'M125',
    hasModel: false
  },
  {
    number: 'M126',
    hasModel: false
  },
  {
    number: 'M127',
    hasModel: false
  },
  {
    number: 'M128',
    hasModel: false
  },
  {
    number: 'M129',
    hasModel: false
  },
  {
    number: 'M130',
    hasModel: false
  },
  {
    number: 'M131',
    hasModel: false
  },
  {
    number: 'M132',
    hasModel: false
  },
  {
    number: 'M133',
    hasModel: false
  },
  {
    number: 'M134',
    hasModel: false
  },
  {
    number: 'M135',
    hasModel: false
  },
  {
    number: 'M136',
    hasModel: false
  },
  {
    number: 'M137',
    hasModel: false
  },
  {
    number: 'M138',
    hasModel: false
  },
  {
    number: 'M139',
    hasModel: false
  },
  {
    number: 'M140',
    hasModel: false
  },
  {
    number: 'M141',
    hasModel: false
  },
  {
    number: 'M142',
    hasModel: false
  },
  {
    number: 'M143',
    hasModel: false
  },
  {
    number: 'M144',
    hasModel: false
  },
  {
    number: 'M145',
    hasModel: false
  },
  {
    number: 'M146',
    hasModel: false
  },
  {
    number: 'M147',
    hasModel: false
  },
  {
    number: 'M148',
    hasModel: false
  },
  {
    number: 'M149',
    hasModel: false
  },
  {
    number: 'M150',
    hasModel: false
  },
  {
    number: 'M151',
    hasModel: false
  },
  {
    number: 'M152',
    hasModel: false
  },
  {
    number: 'M153',
    hasModel: false
  },
  {
    number: 'M154',
    hasModel: false
  },
  {
    number: 'M155',
    hasModel: false
  },
  {
    number: 'M156',
    hasModel: false
  },
  {
    number: 'M157',
    hasModel: false
  },
  {
    number: 'M158',
    hasModel: false
  },
  {
    number: 'M159',
    hasModel: false
  },
]